import { type DependencyList, type EffectCallback, useEffect } from "react";

export function useAnalyticsEffect(
  effect: EffectCallback,
  dependencies?: DependencyList
) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(
    effect,
    dependencies?.map((x) => JSON.stringify(x))
  );
}
